<template>
  <BaseTemplate>
    <div class="confirm-buy-point">
      <Title eng="BUY POINTS" jpn="ポイント購入完了" />
      <div class="area_box">
        <div class="point-value-area">
          <div class="title">番号確認URL</div>
          <ShadowBox class="shadow-box point" opacity="_60">
            <span><a :href="url" target="_blank">{{url}}</a></span>
          </ShadowBox>
          <span class="text">上記情報でコンビニ支払いを行って下さい。</span>
        </div>
      </div>
      <div class="button-area">
        <BlackGradationButton
          class="square-button"
          text="TOPに戻る"
          @handleSquareBtnClick="goTop"
        />
      </div>
    </div>
  </BaseTemplate>
</template>

<script>
import BaseTemplate from '@/components/templates/BaseTemplate.vue';
import ShadowBox from '@/components/atoms/ShadowBox.vue';
import BlackGradationButton from '@/components/atoms/BlackGradationButton.vue';
import Title from '@/components/molecules/Title.vue';
import axios from 'axios';

export default {
  name: 'ConfirmCombini',

  components: {
    BaseTemplate,
    ShadowBox,
    BlackGradationButton,
    Title,
  },

  data: () => ({
    url: '',
  }),

  created() {
    const axiosCtrl = axios.create();
    axiosCtrl.get('/api/user/point/combini_number').then(
      (res) => {
        this.url = res.data.url;
      },
    ).catch(
      () => {
        window.alert('決済会社との接続ができませんでした。\nしばらくしてから再度お試しください。');
      },
    );
  },

  methods: {
    goTop() {
      this.$router.push('/');
    },
  },
};
</script>

<style lang="scss" scoped>
.confirm-buy-point{
  width: 100%;
  max-width: 1800px;
  min-height: 100%;
  padding: 30px 24px 25px 24px;
  margin: 0 auto;
  text-align: center;
  .area_box {
    max-width: 680px;
    margin-left: auto;
    margin-right: auto;
  }
  .confirm-buy-point-title{
    font-family: $notoSansJP;
    font-size: 30px;
    font-weight: 700;
    // color: $white;
  }
  .point-value-area{
    margin-top: 30px;
    margin-left: auto;
    margin-right: auto;
    // color: $white;
    .shadow-box{
      display: flex;
      justify-content: center;
      align-items: center;
      width: 100%;
      height: 60px;
      margin-top: 5px;
      border-radius: 6px;
      font-family: $notoSansJP;
      font-size: 30px;
      font-weight: 700;
      &.point{
        // color: $white;
        border: 1px solid $white;
        margin-bottom: 10px;
      }
      &.value{
        // color: $white;
        border: 1px solid $white;
      }
    }
    .text{
      display: inline-block;
      margin-top: 5px;
      font-family: $notoSansJP;
      font-size: 16px;
      font-weight: 500;
      // color: $white;
      line-height: 29px;
    }
  }
  .select-payment{
    margin-top: 10px;
  }
  .confirm.text{
    display: inline-block;
    margin-top: 19px;
    font-family: $notoSansJP;
    font-size: 18px;
    // color: $white;
  }
  .button-area{
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 30px;
    .square-button{
      width: 240px;
      height: 50px;
      & + .square-button{
        margin-left: 30px;
      }
    }
  }
}
@media screen and  (max-width: $tabletWidth) {
  .confirm-buy-point {
    padding: 30px 10px 25px 10px;
  }
}
</style>
